export default "__VITE_ASSET__DhXa0DBV__"